export class LogRocketEvent {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public readonly payload: {
      name: string;
      unique?: boolean;
      [key: string]:
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | undefined;
    },
  ) {
    // empty
  }
}
